import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "img", "caption", "counter"]

  connect() {
    this.slides = JSON.parse(this.element.dataset.lightboxSlides)
    this.current = 0
    this._onKeydown = this._onKeydown.bind(this)
  }

  open(event) {
    this.current = parseInt(event.currentTarget.dataset.lightboxIndex)
    this._show()
    document.addEventListener("keydown", this._onKeydown)
    document.body.style.overflow = "hidden"
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.removeEventListener("keydown", this._onKeydown)
    document.body.style.overflow = ""
  }

  prev() {
    this.current = (this.current - 1 + this.slides.length) % this.slides.length
    this._show()
  }

  next() {
    this.current = (this.current + 1) % this.slides.length
    this._show()
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  _show() {
    const slide = this.slides[this.current]
    this.imgTarget.src = slide.src
    this.imgTarget.alt = slide.caption || ""
    this.captionTarget.textContent = slide.caption || ""
    this.captionTarget.classList.toggle("hidden", !slide.caption)
    this.counterTarget.textContent = `${this.current + 1} / ${this.slides.length}`
    this.overlayTarget.classList.remove("hidden")
  }

  _onKeydown(e) {
    if (e.key === "ArrowLeft")  this.prev()
    if (e.key === "ArrowRight") this.next()
    if (e.key === "Escape")     this.close()
  }
}
